import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import ExploreAKD from './ExploreAsk';
import OnlineTeacher from './OnlineTeachers';
import UpcomingCourses from './UpcomingCourses';
import ExploreAskSlider from './ExploreAskSlider';
import OnlineTeachersSlider from './OnlineTeachersSlider';
import UpcomingCoursesSlider from './UpcomingCoursesSlider';
import { BrowserView, MobileView } from "react-device-detect";

  class Home extends Component {
    componentWillMount = () => {
        let user = JSON.parse(localStorage.getItem("userDetail"));
        return user?.token
        ? this.props.history.push("/tutor-dashboard/home")
        : this.props.history.push("/");
    };

    render() {
        return(
            <div>
                <BrowserView>
                    <ExploreAKD />
                    <UpcomingCourses/>
                    <OnlineTeacher />
                </BrowserView>
                <MobileView>
                    <ExploreAskSlider />
                    <UpcomingCoursesSlider />
                    <OnlineTeachersSlider />
                </MobileView>
            </div>
        );
    }
}

export default withRouter(Home);